import {
  createBrowserRouter,
} from "react-router-dom";
import { Login } from './pages/Login';
import { Home } from "./pages/Home";
import { ActivityHistory } from "./pages/ActivityHistory";
import { Rewards } from "./pages/Rewards";

const router = createBrowserRouter([
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/",
      element: <Home />,
    },
    {
      path: '/activity-history',
      element: <ActivityHistory />,
    },
    {
      path: '/rewards',
      element: <Rewards />,
    }
  ]);

export { router }